import React, { useState } from "react";
import "./SorterDropDown.scss";
import IconViewer from "../../Assets/svg/IconViewer";

const SorterDropDown = ({
  options,
  activeItems,
  setActiveItems,
  title,
  searchMode,
  sorterMode,
  cardData,
  setCardData,
  callback,
  onSearch,
}) => {
  const handleItemClick = (option, callback) => {
    if (activeItems.includes(option)) {
      setActiveItems(activeItems.filter((item) => item !== option));
    } else {
      setActiveItems([...activeItems, option]);
    }
    callback();
  };

  //toggle handler
  const [toggle, setToggle] = useState(false);
  const toggleHandler = () => {
    setToggle(!toggle);
  };

  // get serach input value
  const [searchText, setSearchText] = useState("");
  // make li based on a filtereData
  const [filteredData, setFilteredData] = useState(options);

  // Function to handle search input change
  const handleSearchInputChange = (event) => {
    const searchText = event.target.value;
    setSearchText(searchText);

    // Filter data based on search input
    const filteredData = options.filter((option) => {
      if (typeof option === "string") {
        return option.toLowerCase().includes(searchText.toLowerCase());
      }
      return false; // Non-string values will not be included in the filtered data
    });
    //update all productData based on a filter searchInput
    setFilteredData(filteredData);
  };

  //when sorterMode === 'search'
  const handleSearchInputAllContent = (event) => {
    const searchText = event.target.value;
    setSearchText(searchText);
    onSearch("text", searchText);

    // const dataResponse = [...cardData];

    // Filter data based on search input
    // const filteredData = dataResponse.filter((v) => {
    //   if (typeof v.title === "string") {
    //     return v.title.toLowerCase().includes(searchText.toLowerCase());
    //   }
    //   return false; // Non-string values will not be included in the filtered data
    // });
    // setCardData(filteredData);
  };

  return (
    <div className="sorterDropDownPrnt_">
      <div className="titleSorterPrnt_">
        <span className="titleSorter_">{title}</span>
        {sorterMode !== "search" && (
          <div
            className={toggle ? "toggle_active" : "icon__"}
            onClick={toggleHandler}
          >
            <IconViewer icon={"ArrowUp"} />
          </div>
        )}
      </div>
      {sorterMode === "search" ? (
        <div className={"sercherContent_"}>
          <div className="searchBox__">
            <input
              type="text"
              placeholder="جستجو کنید"
              value={searchText}
              onChange={handleSearchInputAllContent}
            />
            <div className="searchIcon__">
              <IconViewer icon={"SearchIcon"} />
            </div>
          </div>
        </div>
      ) : (
        <div
          className={
            toggle === false ? "sorterListContent_" : "sorterListContent_active"
          }
        >
          {searchMode === true && (
            <div className="searchBox__">
              <input
                type="text"
                placeholder="جستجو کنید"
                value={searchText}
                onChange={handleSearchInputChange}
              />
              <div className="searchIcon__">
                <IconViewer icon={"SearchIcon"} />
              </div>
            </div>
          )}

          <ul className={"sorterListUI_"}>
            {filteredData.map((option, index) => {
              return (
                <li
                  className={`lists__ ${
                    activeItems.includes(option) ? "sorterListUI_active" : ""
                  }`}
                  onClick={() => handleItemClick(option, callback)}
                  key={index}
                >
                  <span className="circle__"></span>
                  {option}
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default SorterDropDown;

// import React from 'react';

// const SorterDropdown = ({ options, activeItems, setActiveItems}) => {
//   // const [activeItems, setActiveItems] = useState([]);

//   const handleItemClick = (option) => {
//     if (activeItems.includes(option)) {
//       setActiveItems(activeItems.filter((item) => item !== option));
//     } else {
//       setActiveItems([...activeItems, option]);
//     }
//   };

//   return (
//     <div className="sorter-dropdown">
//       <ul className="dropdown-list">
//         {options.map((option) => (
//           <li
//             key={option}
//             className={`dropdown-item ${activeItems.includes(option) ? 'active' : ''}`}
//             onClick={() => handleItemClick(option)}
//           >
//             {option}
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default SorterDropdown;
